import styled from '@emotion/styled';

export const Menu = styled.div`
overflow-y: auto`;
